// extracted by mini-css-extract-plugin
export default {"container":"Fj-z","links":"Gj-z"};